import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly COUNTRY_SERVICE_URL = '/dpwsvc/v1/ext/code/';
  private readonly COUNTRY_CODE: string = 'ISO_CODE';
  private _countries: Map<string, string> = new Map<string, string>();

  constructor(
    private http: HttpClient, 
    private environmentService: EnvironmentService, 
    private errorService: ErrorService) { }

  public getCountries() {
    this.http.get<Map<string, string>>(this.environmentService.getServer() +
                                      this.COUNTRY_SERVICE_URL +
                                      this.COUNTRY_CODE).subscribe(res => {
      this._countries = res;
    }, error => {
      this.errorService.processError(error);
    });
  }

  public get countries() {
    return this._countries;
  }
}
